'use client'

import Link from 'next/link'

import About from '../../components/card-details/CardDetails'
import Header from '@/components/header/Header'
import Footer from '@/components/Footer/Footer'
import FullProdSlider from '@/components/catalog/FullProdSlider'
// import logoMain from '@/assets/img/logo-main.svg'
import logoMain from '@/assets/img/dark-vers.svg'
import Image from 'next/image'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import MainSceneWithWrapper from '@/components/MainSceneWithWrapper/MainSceneWithWrapper'
import MainOrder from '@/components/main/MainOrder'
import NewsGallerySlider from '@/components/news/NewsGallerySlider'
import NewsGalleryVideo from '@/components/news/NewsGalleryVideo'
import { detailGallery } from '@/assets/data/detail-gallery'
import CardSlider from '@/components/CardSlider'
import MainAbout from '@/components/main/MainAbout'
import Assortment from '@/components/trading/Assortment'
import { AboutUsVitamin } from '@/components/about-us/AboutUsVitamin'
import ForPartners from '@/components/ForPartners/ForPartners'
import { useTranslation } from 'react-i18next'

// const cardSlideItem = {
//     page: 'main',
//     items: [
//         {
//             title: 'История',
//             listItems: [
//                 'Компания успешно работает на рынке c 1999 года.',
//                 'Первый завод был запущен в Волгограде в 2009 году.',
//                 'Открытие второго завода в Липецкой области, создание аналитического центра «Мегамикс» – в 2016 году.',
//                 'Свыше 30% отечественного комбикорма производится на основе премиксов «Мегамикс» в 2018 году.',
//                 'Приобретение кормового завода в Наро-Фоминском районе Московской области в 2019 году.'
//             ],
//             cardClass: 'product__slide'
//         },
//         {
//             title: 'Стратегия',
//             text: [
//                 'ГК МЕГАМИКС следует стратегии устойчивого развития, которая включает в себя:'
//             ],
//             listItems: [
//                 'Укрепление существующих позиций и развитие новых рынков сбыта',
//                 'Непрерывное совершенствование и модернизацию производственных мощностей',
//                 'Постоянное развитие собственного научно-исследовательского кластера',
//                 'Разработку уникального решения для каждого партнера и улучшение условий для профессионального роста каждого сотрудника.'
//             ],
//             cardClass: 'product__slide'
//         },
//         {
//             title: 'Миссия',
//             text: [
//                 'Мы — крупнейший в России производитель премиксов, комбикормов и белково-витаминно-минеральных добавок. Доля компании на международном рынке 1%, и одни из крупнейших в Европе.'
//             ],
//             quote: true,
//             cardClass: 'product__slide'
//         }
//     ]
// }



// const aboutItem = {
//     // page: 'main',
//     items: [
//         {
//             title: 'История',
//             text: [
//                 'Компания успешно работает на рынке c 1999 года.',
//                 'Первый завод был запущен в Волгограде в 2009 году.',
//                 'Открытие второго завода в Липецкой области, создание аналитического центра МЕГАМИКС – в 2016 году.',
//                 'Свыше 30% отечественного комбикорма производится на основе премиксов МЕГАМИКС в 2018 году.',
//                 'Приобретение кормового завода в Наро-Фоминском районе Московской области в 2019 году.'
//             ],
//             cardClass: 'product__slide'
//         },
//         {
//             title: 'Миссия',
//             text: [
//                 'Задавая стандарты отрасли кормления животных, мы каждый день заботимся о благополучии людей. Мы кормим тех, кто кормит нас.'
//             ],
//             quote: true,
//             cardClass: 'product__slide'
//         },
//         {
//             title: 'Стратегия',
//             text: ['ГК «Мегамикс» следует стратегии устойчивого развития, которая включает в себя:'],
//             listItems: [
//                 'Укрепление существующих позиций и развитие новых рынков сбыта',
//                 'Непрерывное совершенствование и модернизацию производственных мощностей',
//                 'Постоянное развитие собственного научно-исследовательского кластера',
//                 'Разработку уникального решения для каждого партнера и улучшение условий для профессионального роста каждого сотрудника.'
//             ],
//             cardClass: 'product__slide'
//         }
//     ],
//     btn: {
//         content: 'Видео',
//         icon: 'video'
//     },
//     btn2: {
//         content: 'Галерея',
//         icon: 'gallery'
//     }
// }


const headSliderList = ['о компании', 'история', 'стратегия', 'цитата']



const TradingModule = ({ data }: { data: void }) => {
    const dispatch = useDispatch()
    const [galleryOpen, setGalleryOpen] = useState(false)
    const [videoOpen, setVideoOpen] = useState(false)
    const {t} = useTranslation()

    const laboratoryHeadSliderList = [t('about_center'), t('reputation'), t('technologies'), t('perspectives')]

const laboratoryItem = {
    items: [
        {
            title:t('analytics_center'),
            text: [
                t('the_most_effective_quality_control_system'),
                t('understanding_the_importance_of_feed_safety'),
                t('analytical_center_MEGAMICS_is_the_first_in_Russia_accredited'),
                t('thanks_to_highly_qualified_specialists_and_modern_high_tech')
            ],
            cardClass: 'product__slide'
        },
        {
            title: t('reputationUpper'),
            text: [
                t('the_most_effective_quality_control_system'),
                t('understanding_the_importance_of_feed_safety'),
                t('analytical_center_MEGAMICS_is_the_first_in_Russia_accredited'),
                t('thanks_to_highly_qualified_specialists_and_modern_high_tech')
            ],
            cardClass: 'product__slide'
        },
        {
            title: t('technologiesUpper'),
            text: [
                t('the_most_effective_quality_control_system'),
                t('understanding_the_importance_of_feed_safety'),
                t('analytical_center_MEGAMICS_is_the_first_in_Russia_accredited'),
                t('thanks_to_highly_qualified_specialists_and_modern_high_tech')
            ],
            cardClass: 'product__slide'
        },
        {
            title: t('perspectivesUpper'),
            text: [
                t('the_most_effective_quality_control_system'),
                t('understanding_the_importance_of_feed_safety'),
                t('analytical_center_MEGAMICS_is_the_first_in_Russia_accredited'),
                t('thanks_to_highly_qualified_specialists_and_modern_high_tech')
            ],
            cardClass: 'product__slide'
        }
    ],
    btn: {
        content: t('to_the_lab'),
        link: '/labs',
        icon: 'sphera',
        isBlank: true
    }
}

    const orderItem = {
        tag: t('forCustomers'),
        title: t('realization_of_materials'),
        text: [
            t('we_are_the_largest_importer_of_feed_additives'),
            t('we_guarantee_a_minimum_shipment_batch'),
            t('a_well_developed_network_of_warehouse_centers')
        ],
        btn: {
            content: t('details'),
            link: '#assortment',
            icon: 'details'
        },
    }
    

    const vitamin = {
        tag: t('product_lower_case'),
        title: t('Vitamin_E_Innovit'),
        text: [
            t('MEGAMIX_Group_invests_in_the_creation_of_production_of_a_strategic')
        ]
    }


    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
        dispatch(setResetCatalogFilters())
    }, [])

    return (
        <main className='main trading'>
            {/* <div className="home__light-blue"></div>
            <div className="home__purple-1"></div>
            <div className="home__purple-2"></div>
            <div className="home__violet"></div> */}
            <NewsGallerySlider
                type='static'
                isOpen={galleryOpen}
                setIsOpen={state => setGalleryOpen(state)}
                list={detailGallery}
            />
            <NewsGalleryVideo
                isOpen={videoOpen}
                setIsOpen={state => setVideoOpen(state)}
                list={'https://youtu.be/9WqghWyEYeA?si=pc8l_nsBYAyduPSd'}
            />
            <Header 
            burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)' />
            <MainSceneWithWrapper zInx={-1} bottomBlur />
            <div className='main-details trading container'>
                <Link href={'/#map-cards'}>
                    <button className='buttons buttons__maps'>
                        <svg
                            width='19'
                            height='19'
                            viewBox='0 0 19 19'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <g opacity='0.6'>
                                <path
                                    d='M1 3.34483L5.95833 1V15.6552L1 18V3.34483Z'
                                    stroke='#CBD9F9'
                                    strokeWidth='1.6'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                />
                                <path
                                    d='M12.3334 3.34483L18 1V15.6552L12.3334 18V3.34483Z'
                                    stroke='#CBD9F9'
                                    strokeWidth='1.6'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                />
                                <path
                                    d='M12.3334 3.34483L5.95837 1V15.6552L12.3334 18V3.34483Z'
                                    stroke='#CBD9F9'
                                    strokeWidth='1.6'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                />
                            </g>
                        </svg>
                        {t('BackToMap')}
                    </button>
                </Link>
                {/* <About /> */}
                {/* <FullProdSlider setVideoOpen={(state) => setVideoOpen(state)} setGalleryOpen={(state) => setGalleryOpen(state)} list={cardSlideItem} page='main' type='intro' headSlider={headSliderList} /> */}
                {/* <CardSlider
                    setVideoOpen={state => setVideoOpen(state)}
                    setGalleryOpen={state => setGalleryOpen(state)}
                    list={aboutItem}
                    headSlider={headSliderList}
                    aboutCompany /> */}
                <MainAbout item={orderItem} blank={false}/>
            </div>
            <div className="assortment container">
                <Assortment type='megaschool' id={`assortment`}/>
                <AboutUsVitamin
                    item={vitamin}
                    btnContent={t('sendEnquiry')}
                />
            </div>
            <div className="container">
                <div className="about-us__laboratory">
                    <CardSlider list={laboratoryItem} headSlider={laboratoryHeadSliderList} />
                </div>
                <ForPartners title={t('partners')} />
            </div>
            <Footer />
        </main>
    )
}

export default TradingModule

